import { useEffect, useState } from 'react'
import { EventInterface } from 'common/components/entities/Calendar/calendar-interface'
import { AxiosResponse } from 'axios'
import usePage from 'publisher/hooks/usePage'
import { pageSelectors } from 'publisher/store'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
interface UseEventArgs {
  eventId?: EventInterface['id']
  fetcher: (
    pageId: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<AxiosResponse<{ value: EventInterface['id'] } | null, any>>
}

export const useActualBookingEvent = ({ fetcher }: UseEventArgs) => {
  const [actualEventId, setActualEventId] = useState<EventInterface['id']>()
  const [error, setError] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const { t } = useTypedTranslation()
  const pageId = usePage(pageSelectors.getPageId)
  const fetch = async (pageId: number) => {
    setIsFetching(true)
    try {
      const data = await fetcher(pageId)
      setActualEventId(data.data?.value)
      if (!data.data) {
        setError(t('components.core.paid_calendar.event_not_found'))
      }
    } catch {
      setError(t('core.error.title'))
    } finally {
      setIsFetching(false)
    }
  }
  useEffect(() => {
    if (pageId) fetch(pageId)
  }, [pageId])

  return { actualEventId, isFetching, actualEventError: error, fetch }
}
